import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import * as styles from './Recommendations.css';
import { IManifestInfo } from '../../types/manifestInfo';
import classNames from 'classnames';

interface IRecommendationsProps {
  manifestInfo: IManifestInfo;
  regionId: number;
  landingType: string;
  showFullList: number;
}

export const Recommendations: React.FC<IRecommendationsProps> = ({
  manifestInfo,
  regionId,
  landingType,
  showFullList = 0,
}) => (
  <section
    className={classNames('cg-container-fluid-xs', styles['container'], !!showFullList && styles['reset-padding'])}
  >
    <Microfrontend {...manifestInfo} parameters={{ regionId, landingType, showFullList }} />
  </section>
);
